import React from "react";
import { darkTheme } from "@yleisradio/yds-core";
import styled from "styled-components";

import { ONGOING_STATES } from "../../../constants";
import { useEmbedParametersContext } from "../../../contexts/embedParametersContext";
import { State } from "../../../enums";
import i18n from "../../../service/i18n";
import { usePlayerStore } from "../../../store/usePlayerStore";
import { ErrorPayloadType, SetPlayerApiFn } from "../../../types/common";
import { NonPlayableAudio } from "../NonPlayable/NonPlayableAudio";
import YleAudioPlayer from "../YleAudioPlayer";

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const AudioErrorText = styled.div`
  color: ${darkTheme.FEEDBACK_ERROR};
`;

const isErrorType = (error?: ErrorPayloadType): error is Error =>
  !!error && error instanceof Error;

export const PreviewAudio = ({
  setPlayerApi,
  setPlayerApiSimple,
  state
}: {
  setPlayerApi: SetPlayerApiFn;
  setPlayerApiSimple: () => void;
  state: State;
}) => {
  const { useStoreState } = usePlayerStore();
  const error = useStoreState.error();
  const mediaData = useStoreState.media();
  const { language } = useEmbedParametersContext();

  const isPlayable = ONGOING_STATES.includes(state) && !!mediaData;

  // If error is 404 api error (media not found), no need to show red "Äänentoistossa tapahtui virhe" error message,
  // because the playback button already tells the user that the media is not available
  // Error message can appear also if media is ongoing, if there is error during playback
  const showErrorMessage =
    !!error &&
    (!isErrorType(error) || error.message !== "API responds with 404");

  return (
    <Container>
      {showErrorMessage && (
        <AudioErrorText>
          {i18n("aanentoistossa_tapahtui_virhe", { language })}
        </AudioErrorText>
      )}
      {isPlayable && (
        <YleAudioPlayer setPlayerApi={setPlayerApi} state={state} />
      )}
      {!isPlayable && (
        <NonPlayableAudio
          setPlayerApiSimple={setPlayerApiSimple}
          state={state}
        />
      )}
    </Container>
  );
};
